export class Responsible {
    _id = '';
    name = '';
    username = '';

    loadUser(r: any) {
        if (r._id === undefined)
            return null;

        this._id = r._id;
        this.name = r.name;
        this.username = r.username;

        return this;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/Responsible.model.ts